import { Flex, Text } from 'ui'

import { usePulseContext } from '../../context/PulseProvider'
import { MetricBox } from '../MetricBox'
import { useRatingMetrics } from 'queries/pulse/useRatingMetrics'
import { formatPercentage } from 'lib/string'
import { MetricsDiff } from '../MetricsDiff'
import { formatTimePeriodDate } from 'pages/PulsePage/utils'

export function RatingMetrics() {
  const {
    state: { filters },
  } = usePulseContext()

  const { data, isLoading } = useRatingMetrics(filters)

  const currentPeriodData = data?.[0]
  const previousPeriodData = data?.[1]

  const avgWorkerRatingByManagerDelta =
    previousPeriodData?.avg_worker_rating_by_manager
      ? ((currentPeriodData?.avg_worker_rating_by_manager ?? 0) -
          previousPeriodData.avg_worker_rating_by_manager) /
        previousPeriodData.avg_worker_rating_by_manager
      : 0
  const avgWorkerRatingByManagerDirection =
    avgWorkerRatingByManagerDelta >= 0 ? 'up' : 'down'

  const avgShiftRatingByWorkerDelta =
    previousPeriodData?.avg_shift_rating_by_worker
      ? ((currentPeriodData?.avg_shift_rating_by_worker ?? 0) -
          previousPeriodData.avg_shift_rating_by_worker) /
        previousPeriodData.avg_shift_rating_by_worker
      : 0
  const avgShiftRatingByWorkerDirection =
    avgShiftRatingByWorkerDelta >= 0 ? 'up' : 'down'

  return (
    <Flex
      flexWrap={'wrap'}
      flexDirection={['column', 'row', 'row']}
      justifyContent="space-between"
      gap={2}
    >
      <MetricBox
        title="Avg. Rating by Managers to Workers"
        value={`${(
          currentPeriodData?.avg_worker_rating_by_manager ?? 0
        ).toFixed(2)} / 5`}
        isLoading={isLoading}
      >
        {!!currentPeriodData?.shift_date && (
          <Text fontSize="3" mb={1}>
            {formatTimePeriodDate(
              filters.timePeriod,
              currentPeriodData?.shift_date
            )}
          </Text>
        )}
        <Text fontSize="2">
          <MetricsDiff
            value={formatPercentage(avgWorkerRatingByManagerDelta)}
            direction={avgWorkerRatingByManagerDirection}
          />{' '}
          vs{' '}
          {previousPeriodData?.shift_date
            ? formatTimePeriodDate(
                filters.timePeriod,
                previousPeriodData?.shift_date
              )
            : 'previous period'}
          : {previousPeriodData?.avg_worker_rating_by_manager?.toFixed(2)}
        </Text>
      </MetricBox>
      <MetricBox
        title="Avg. Rating by Workers to Shifts"
        value={`${(currentPeriodData?.avg_shift_rating_by_worker ?? 0).toFixed(
          2
        )} / 5`}
        isLoading={isLoading}
      >
        {!!currentPeriodData?.shift_date && (
          <Text fontSize="3" mb={1}>
            {formatTimePeriodDate(
              filters.timePeriod,
              currentPeriodData?.shift_date
            )}
          </Text>
        )}
        <Text fontSize="2">
          <MetricsDiff
            value={formatPercentage(avgShiftRatingByWorkerDelta)}
            direction={avgShiftRatingByWorkerDirection}
          />{' '}
          vs{' '}
          {previousPeriodData?.shift_date
            ? formatTimePeriodDate(
                filters.timePeriod,
                previousPeriodData?.shift_date
              )
            : 'previous period'}
          : {previousPeriodData?.avg_shift_rating_by_worker?.toFixed(2)}
        </Text>
      </MetricBox>
      <MetricBox
        title="Rate of Workers rating Shift 1, 2, or 3"
        value={`${(
          ((currentPeriodData?.number_workers_rated_shift_below_3 ?? 0) /
            (currentPeriodData?.count_shift_rating_by_worker ?? 0)) *
          100
        ).toFixed(1)}%`}
        isLoading={isLoading}
      />
      <MetricBox
        title="Rate of Managers rating worker 1, 2, or 3"
        value={`${(
          ((currentPeriodData?.number_managers_rated_worker_below_3 ?? 0) /
            (currentPeriodData?.count_worker_rating_by_manager ?? 0)) *
          100
        ).toFixed(1)}%`}
        isLoading={isLoading}
      />
    </Flex>
  )
}
